import { CMSocialMedia } from "./social-media.styles";
import { ReactComponent as FbIcon } from "../../icons/facebook.svg";
import { ReactComponent as SharingIcon } from "../../icons/sharing.svg";
import { ReactComponent as StarIcon } from "../../icons/star.svg";
import { ReactComponent as Twitter } from "../../icons/twitter-x.svg";
import { ReactComponent as TwitterFooter } from "../../icons/twitter-x-2.svg";
import { ReactComponent as Tiktok } from "../../icons/tiktok.svg";
import { ReactComponent as Instagram } from "../../icons/instagram2.svg";
import { ReactComponent as FilledStarIcon } from "../../icons/star-filled.svg";
import { useState } from "react";
import { Link } from "react-router-dom";
import { Star } from "@mui/icons-material";

const SocialMedia = (props) => {
  const [filled, setFilled] = useState(false);

  const onClickStart = () => {
    setFilled((old) => !old);
    console.log('filled',filled);
  };

  const subjectEmail = "subject=Take%20a%20look%20at%20this%20page";
  const bodyEmail = "body=Hello!%20I%20would%20like%20to%20share%20this%20page%20with%20you%20"
  const uri = "https://stg.themusicbull.com/"
  return (
    <CMSocialMedia {...props}>
      {filled ? (
        <FilledStarIcon onClick={onClickStart} style={props.hide} />
      ) : (
        <StarIcon onClick={onClickStart} style={props.hide} />
      )}

      <a href={"https://www.facebook.com/Musicbulltrade/"} target="_blank">
        <FbIcon style={props.style} />
      </a>
      <a href={"https://twitter.com/themusicbull" } target="_blank" >
      {props.footer === 1 ? (
        <TwitterFooter style={props.style} />
      ) : (
        <Twitter style={props.style} />
      )}
      </a>
      <a href={"https://www.instagram.com/musicbulltrade/"} target="_blank">
        <Instagram style={props.style} />
      </a>
      <a href={"https://www.tiktok.com/@themusicbull"} target="_blank">
        <Tiktok style={props.style} />
      </a>
      { console.log('props', props)}
      <a href={`mailto:?${subjectEmail}&${bodyEmail}${uri}`} target="_blank">
        <SharingIcon style={props.style} />
      </a>
    </CMSocialMedia>
  );
};

export default SocialMedia;
